/**
 * Fix to disable show prescription "Add" in table
 * @type {string}
 */

// non prescription option for glasses
export const USEFOR_OPTION = '4036';

// Glasses types identifier numbers in constants,
// named as conforming Glasses types.("Use for"-block in product wizard)
export const NOPRESCRIPTION = 'Frame';
export const DISTANCE = 'Single-Vision';
export const PROGRESSIVES = 'Progressive';
export const BIFOCAL = 'Bifocal';
export const READING = 'Reading';
export const DISTANCE_AND_READING = 'distance_and_reading';

export const SEND_BY_NOW = '1';
export const SEND_BY_UPLOAD = '4';
export const SEND_BY_LATER = '3';
export const SEND_BY_SAVED = '1';

export const NOT_SELECTED = 0 as const;
export const FILL_IT = 1 as const;
export const UPLOAD = 4 as const;
export const SEND_LATER = 3 as const;

export const TRANSITION = 'Transitions®';

export const DISTANCE_AND_READING_DESCRIPTION = {
    id: DISTANCE_AND_READING,
    sku: DISTANCE_AND_READING,
    optionId: 0, // this value defines in the groupUsage selector.
    title: 'Distance & Reading',
    subtitle: 'Multifocal',
    description: 'Provide seamless progression between optical powers for all viewing distances.',
    position: 3,
};

export const DISTANCE_AND_READING_USAGE = {
    id: '',
    sku: DISTANCE_AND_READING,
    packageGroupId: 0,
    insuranceKey: '',
};

export const LENSES_PRESCRIPTION_UPLOAD_TYPE_ID = 4;
export const SAVED_PRESCRIPTION_KEY = 'wizardSavedPrescription';

export const TRACKED_DETAILS: {[key: string]: string} = {
    [FILL_IT]: 'Dr. Details',
    [SEND_LATER]: 'Prescription Image',
};
